<template>
  <div class="detial2">
    <div class="img2" style="position: relative;">
      <div
        class="mack"
        :height="bannerHeight+'px'"
          style="
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: black;
          opacity: 0.4;
        "
      ></div>
      <div :height="bannerHeight+'px'">
      <img
      ref="bannerHeight"
      @load="imgLoad"
      style="display: block;width: 100%;height: 100%;"
      :src="banner"
      alt=""
      />
    </div>
      <div class="aside2">
        <p class="title2">{{ name }}</p>
        <p class="desc2">
          {{ desc }}
        </p>
      </div>
    </div>
    <div class="content2">
      <div class="wrapper2">
        <div class="info" v-html="info"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      bannerHeight: "",
    }
  },
  computed: {
    ...mapState("solution", ["banner", "name", "desc", "info"]),
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
  },
};
</script>

<style lang="less" >
@media screen and (min-width: 1200px) {
  .detial2 {
    .img2 {
      position: relative;
      width: 100%;
      // height: 4.6rem;
      img {
        width: 100%;
        height: 100%;
      }
      .aside2 {
        position: absolute;
        top: 0.5rem;
        left: 0.2rem;
        padding: 10px 150px 10px 10px;
        color: aliceblue;
        .title2 {
          font-size: 0.45rem;
          padding-bottom: 0.2rem;
        }
        .desc2 {
          // width: 4rem;
          font-size: 0.2rem;
          margin-right: 0;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
        }
      }
    }
    .content2 {
      margin-top: 0.5rem;
      .wrapper2 {
        // text-align: center;
        width: 12rem;
        margin: 0 auto;
        color: rgb(227, 233, 238);
        .info {
          p {
            line-height: 24px;
            width: 100%;
            height: auto;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            text-align: center;
          }
          img {
            // margin: 0 280px;
            width: 1000px !important;
            // height: 400px !important;
          }
          video {
            margin: 0 280px;
            width: 710px;
            height: 400px;
            overflow: hidden;
            border: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .detial2 {
    min-height: 5rem;
    .img2 {
      position: relative;
      // width: 100%;
      // height: 1.5rem;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
      .aside2 {
        position: absolute;
        top: 0.1rem;
        left: 0.05rem;
        padding: 0.03rem 0.3rem 0.1rem 0.1rem;
        color: aliceblue;
        .title2 {
          font-size: 0.12rem;
          padding-bottom: 0.05rem;
        }
        .desc2 {
          font-size: 0.08rem;
          margin-right: 0;
          line-height: 0.10rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
        }
      }
    }
    .content2 {
      margin-top: 0.1rem;
      .wrapper2 {
        // text-align: center;
        width: 3.2rem;
        margin: 0 auto;
        color: rgb(227, 233, 238);
        .info {
          p {
            line-height: 0.18rem;
            width: 100%;
            height: auto;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
            font-size: 0.1rem;
          }
          img {
            margin: 0 0.4rem !important;
            width: 2.5rem !important;
            height: 1.5rem !important;
          }
          video {
            margin: 0 0.4rem;
            width: 2.5rem;
            height: 1.5rem;
            overflow: hidden;
            border: none;
          }
        }
      }
    }
  }
}
</style>